module.exports = __webpack_public_path__ + "static/media/navidad15.48335c84.jpg";